import { InjectionToken } from '@angular/core';

export const ENTITY_API_CONFIG = new InjectionToken<string>('entity_api_config');

export interface EntityApiConfig
{
    url: string;
}